export default __webpack_public_path__ + "static/typing-9d1f2511b201fd07fd965b309de8af73.mp4";